import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";

// 00:17:34 = 1054 seconds, restarts automatically
const START_SECONDS = 17 * 60 + 34;
type CountdownProps = {
  tone?: "light" | "dark";
};
export function Countdown({
  tone = "light"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(START_SECONDS);
  const label = tone === "dark" ? "text-goldSoft" : "text-forest";
  const sep = tone === "dark" ? "text-white/70" : "text-forest";
  const unit = (value: string, caption: string) => <div className="flex flex-col items-center" data-id="element-20" data-mp="3gyw71w7cwtky">
      <div className={`flex h-16 w-16 items-center justify-center rounded-xl font-serif text-3xl font-bold tabular-nums sm:h-20 sm:w-20 sm:text-4xl ${tone === "dark" ? "bg-white text-forestDark" : "bg-forestDark text-white"}`} data-id="element-21" data-mp="324hxsndlgyjh">
        {value}
      </div>
      <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${tone === "dark" ? "text-white/70" : "text-muted"}`} data-id="element-22" data-mp="15by41k3fy5kf">
        {caption}
      </span>
    </div>;
  return <div className="mt-6 flex flex-col items-center" role="timer" aria-live="off" data-id="element-23" data-mp="t2ljx8ezti17">
      <p className={`mb-3 flex items-center gap-2 text-sm font-bold uppercase tracking-wide ${label}`} data-id="element-24" data-mp="17qzts3atu6r9">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-25" data-mp="12s55ilu3bpzr" />
        Special offer ends in:
      </p>
      <div className="flex items-start gap-2" data-id="element-26" data-mp="f22dg5q6ek15">
        {unit(hours, "Hours")}
        <span className={`mt-3 font-serif text-3xl font-bold ${sep}`} data-id="element-27" data-mp="f45dlil1ltjl">:</span>
        {unit(minutes, "Minutes")}
        <span className={`mt-3 font-serif text-3xl font-bold ${sep}`} data-id="element-28" data-mp="o30hgo0m6rjq">:</span>
        {unit(seconds, "Seconds")}
      </div>
    </div>;
}